import { FC } from "react";
import Stack from "@mui/material/Stack";
import { useAppSelector } from "@/store/hooks";
import { SavingPlansRecommendationsDataGrid } from "@/components/pages/commtiments/utilization-and-coverage/components/content/recommendations/SavingPlansRecommendationsDataGrid";
import { RecommendationsTabs } from "@/components/pages/commtiments/recommendations/components/RecommendationsTabs";
import { ReservationsRecommendationsDataGrid } from "@/components/pages/commtiments/reservations/components/content/recomendations/ReservationsRecommendationsDataGrid";
import { commitmentsDataViewTabSelector } from "@/store/commitments/selectors/common/view-options/commitmentsDataViewTabSelector";

export const Recommendations: FC = () => {
  const tab = useAppSelector(commitmentsDataViewTabSelector);

  return (
    <Stack spacing={1} flex={1} pt={1}>
      <RecommendationsTabs />
      {tab === "saving_plans" && <SavingPlansRecommendationsDataGrid />}

      {tab === "reservation" && <ReservationsRecommendationsDataGrid />}
    </Stack>
  );
};
